import { Space } from "antd";
import styled from "styled-components";

export const StyledSpace = styled(Space)`
  flex: 1;
  justify-content: center;
  width: 100%;
`;
StyledSpace.displayName = "StyledSpace";
